import { Auth } from 'aws-amplify';
import { invokeLambdaWithRetry } from 'services/Helper';
import { createUiLogger } from '../../../logging/uiLogger';
const console = createUiLogger('qaStatusRequests');

export async function updateSubmissionsReport(submissionsReportInput, archivedQa) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        ...(archivedQa ? { archivedQa } : {}),
        "access_token": user.signInUserSession.idToken.jwtToken,
        "target": "updateSubmissionsReport",
        "submissionsReportInput": submissionsReportInput
      };
      const init = {
        body: body
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      return data.response;
    } catch (err) {
      if (archivedQa) throw err;
      console.error(err);
      return false;
    }
  }

export async function updateDocument(updateDocumentsInput, archivedQa) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        ...(archivedQa ? { archivedQa } : {}),
        "access_token": user.signInUserSession.idToken.jwtToken,
        "target": "updateDocument",
        "updateDocumentsInput": updateDocumentsInput
      };
      const init = {
        body: body
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      return data.response;
    } catch (err) {
      if (archivedQa) throw err;
      console.error(err);
      return false;
    }
  }
